export default {"src":"/_next/static/media/icon-course.bdea6384.svg","height":16,"width":16};